<template>
  <el-table
    :data="tableData"
    stripe
    border
    style="width: 96%; margin: 0 auto"
    size="mini"
    class="tabWrap"
    height="100%"
    :header-cell-style="{
      'background-color': '#F7F7F7',
    }"
    :cell-style="cellStyle"
    @cell-click="cellClick"
  >
    <el-table-column
      v-for="(v, i) in tabHead"
      :key="i"
      :prop="v.prop"
      :label="v.label"
      :min-width="
        v.label == '设备数量' ||
        v.label == '进度' ||
        v.label == '计划周期' ||
        v.label == '巡检类型' ||
        v.label == '循环周期'
          ? '35'
          : ''
      "
      :show-overflow-tooltip="true"
      align="center"
    >
      <template slot-scope="scope">
        <span
          v-if="
            scope.row[v.prop] &&
            v.prop == 'handleUser' &&
            $route.path == '/controlPage'
          "
        >
          <el-link
            type="primary"
            v-for="(item, index) in scope.row.handlersInfo"
            :key="item.id"
            @click="toUserPage(item)"
            >{{
              index == scope.row.handlersInfo?.length - 1
                ? item.name
                : `${item.name}、`
            }}</el-link
          >
        </span>
        <span v-else>{{ scope.row[v.prop] }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import api from "@/api";
import { dateFtt, flexWidth, matchingWeek } from "@/assets/js/utils";
export default {
  props: {
    planActive: {
      type: String,
      default: "",
    },
  },
  watch: {
    planActive: {
      handler(newvalue, oldvalue) {
        this.getTableHead();
        this.getTableList();
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      tabHead: [],
      tableData: [],
    };
  },
  methods: {
    flexWidth,
    toUserPage(data) {
      this.$router.push({
        name: "authority",
        params: { userId: data.id },
      });
    },
    getTableHead() {
      if (this.planActive == "MAINTENANCE") {
        //保养
        this.tabHead = [
          { label: "保养计划", prop: "name" },
          { label: "设备数量", prop: "deviceSize" },
          { label: "计划执行时间", prop: "planTime" },
          { label: "计划周期", prop: "planPeriod" },
          { label: "计划执行人员", prop: "handleUser" },
          { label: "进度", prop: "degree" },
        ];
      } else if (this.planActive == "INSPECTION") {
        // 巡检
        this.tabHead = [
          { label: "巡检计划", prop: "name" },
          { label: "巡检线路", prop: "routeName" },
          { label: "巡检类型", prop: "type" },
          { label: "循环周期", prop: "cycle" },
          { label: "限时", prop: "planTimeList" },
          { label: "巡检人", prop: "handleUser" },
          { label: "进度", prop: "degree" },
        ];
      }
    },

    async getTableList() {
      this.tableData = [];
      let res = await api.controlGetPlanTalbeData({
        userId: this.$store.state.user.activeUser.id ?? "",
        pageSize: 10000,
        page: 0,
        date: dateFtt("yyyy-MM-dd", new Date()),
        sourceType: this.planActive,
      });
      if (res && res.data.code == 200) {
        this.tableData = res.data.data.data;
        this.tableData.map((v) => {
          v.degree = `${v.done}/${v.deviceSize}`;
          v.handleUser = v.handlersInfo
            ?.map((item) => {
              return item.name;
            })
            .join(",");
          if (this.planActive == "MAINTENANCE") {
            v.planPeriod = v.period ? `${v.period}天/次` : "";
            v.planTime = `${dateFtt(
              "yyyy-MM-dd",
              new Date(v.startTime)
            )}-${dateFtt("yyyy-MM-dd", new Date(v.endTime))}`;
          } else if (this.planActive == "INSPECTION") {
            v.type = v.planType == "CYCLE" ? "循环计划" : "临时计划";
            v.cycle =
              v.planCycle == "DAY"
                ? "每天"
                : v.planCycle == "WEEK"
                ? "每周"
                : v.planCycle == "MONTH"
                ? "每月"
                : "-";
            let str = "";
            if (v.planCycle == "WEEK") {
              v.planTimeLimits.map((v) => {
                return (str += `${matchingWeek(v.typeBeginTime)} ${
                  v.beginTime
                } - ${matchingWeek(v.typeEndTime)} ${v.endTime};`);
              });
            } else {
              v.planTimeLimits.map((v) => {
                return (str += `${v.typeBeginTime} ${v.beginTime} - ${v.typeEndTime} ${v.endTime};`);
              });
            }
            v.planTimeList = str;
          }
        });
      }
    },
    cellStyle(row) {
      if (row.column.label === "保养计划" || row.column.label === "巡检计划") {
        return "color:#28CCCB;cursor: pointer;";
      }
    },
    cellClick(row, column) {
      if (column.label == "保养计划" || column.label === "巡检计划") {
        this.$router.push({
          path: column.label == "巡检计划" ? "/patrolPlan" : "/maintainPlan",
          query: {
            name: row.name,
            id: row.id,
          },
        });
      }
    },
  },
  created() {},
};
</script>

<style></style>
